var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#0075FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4167 22.5625C21.4167 22.194 21.0903 21.875 20.7292 21.875C18.3816 21.875 9.78508 21.875 7.4375 21.875C7.07633 21.875 6.75 22.194 6.75 22.5625C6.75 22.931 7.07633 23.25 7.4375 23.25H20.7292C21.0903 23.25 21.4167 22.931 21.4167 22.5625ZM10.3956 16.0697C9.17275 19.6594 9.03892 19.9491 9.03892 20.2745C9.03892 20.7576 9.46058 20.9611 9.7255 20.9611C10.0482 20.9611 10.3378 20.8355 13.9183 19.5925L10.3956 16.0697ZM11.3672 15.0972L14.8928 18.6227L22.9814 10.5432C23.1602 10.3644 23.25 10.1298 23.25 9.89508C23.25 9.66133 23.1602 9.42667 22.9814 9.24792C22.3471 8.6145 21.3846 7.652 20.7493 7.01858C20.5706 6.83983 20.3359 6.75 20.1013 6.75C19.8684 6.75 19.6337 6.83983 19.4541 7.01858L11.3672 15.0972Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7262739aed1fc6b25ede9dd9058c0860.svg";
export { ForwardRef as ReactComponent };